import { BuilderComponent } from "@builder.io/react";
import { builderClient } from '@/utils/builder';
import { useRouter } from "next/compat/router";
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useNewOrReturningCustomer from '@/helpers/hooks/useNewOrReturningCustomer';
import { getUserCauseDetails } from '@/helpers/charityHelper';
import { removeTargetAttr } from "@/helpers/generalHelper";
import { getUserTierInfo } from "@/helpers/yotpoHelper";

export  function ContentTilePLP1() {
  const router = useRouter();
  const newOrReturningCustomer = useNewOrReturningCustomer();
  const filters = useSelector((state) => state.filters);
  const userCauseDetails = getUserCauseDetails();
  const userCausePartner = typeof userCauseDetails != "undefined" && userCauseDetails && typeof userCauseDetails[0] != "undefined" && userCauseDetails[0]?.short_code;
  const [builderContentJson1, setBuilderContentJson1] = useState("");
  const [buildertile1fetched, setBuildertile1fetched] = useState(false);
  const customerRewardLevel =  getUserTierInfo();
  const isApp = useSelector((state) => state.pwa.is_PWA);

  useEffect(() => {
    builderClient.setUserAttributes({
      urlPath: router.asPath.split("?")[0],
      categories: [
        filters.type.toLowerCase(),
        filters.category.toLowerCase(),
        filters.subcategory.toLowerCase(),
      ],
      categoryMenu: [filters.type, filters.category, filters.subcategory],
      designers: router.query.brand?.toLowerCase(),
      designerMenu: router.query.brand?.toLowerCase(),
      customerType: newOrReturningCustomer,
      causePartner: userCausePartner,
      rewardLevel: customerRewardLevel,
      app: isApp
    });

    if (newOrReturningCustomer) {
      builderClient
        .get("content-tile-plp")
        .promise()
        .then((data) => { setBuilderContentJson1(data) })
        .catch((error)=>{ reportError(error) })
        .finally(() => { setBuildertile1fetched(true) });
    }
    if (buildertile1fetched) {
      removeTargetAttr();
    }
  }, [newOrReturningCustomer, userCausePartner, customerRewardLevel]);

  return (<>
    {buildertile1fetched && <BuilderComponent model="content-tile-plp" content={builderContentJson1} />}
  </>)
}

export function ContentTilePLP2() {
  const router = useRouter();
  const newOrReturningCustomer = useNewOrReturningCustomer();
  const filters = useSelector((state) => state.filters);
  const userCauseDetails = getUserCauseDetails();
  const userCausePartner = typeof userCauseDetails != "undefined" && userCauseDetails && typeof userCauseDetails[0] != "undefined" && userCauseDetails[0]?.short_code;
  const [builderContentJson2, setBuilderContentJson2] = useState("");
  const [buildertile2fetched, setBuildertile2fetched] = useState(false);
  const customerRewardLevel =  getUserTierInfo();
  const isApp = useSelector((state) => state.pwa.is_PWA);

  useEffect(() => {
    builderClient.setUserAttributes({
      urlPath: router.asPath.split("?")[0],
      categories: [
        filters.type.toLowerCase(),
        filters.category.toLowerCase(),
        filters.subcategory.toLowerCase(),
      ],
      categoryMenu: [filters.type, filters.category, filters.subcategory],
      designers: router.query.brand?.toLowerCase(),
      designerMenu: router.query.brand?.toLowerCase(),
      customerType: newOrReturningCustomer,
      causePartner: userCausePartner,
      rewardLevel: customerRewardLevel,
      app: isApp
    });

    if (newOrReturningCustomer) {
      builderClient
        .get("content-tile-plp-2")
        .promise()
        .then((data) => { setBuilderContentJson2(data) })
        .catch((error)=>{ reportError(error) })
        .finally(() => { setBuildertile2fetched(true) });
    }

    if (buildertile2fetched) {
      removeTargetAttr();
    }
  }, [newOrReturningCustomer, userCausePartner, customerRewardLevel]);

  return (<>
    {buildertile2fetched && <BuilderComponent model="content-tile-plp-2" content={builderContentJson2} />}
  </>)
}

